module.exports = __webpack_public_path__ + "static/media/sound-icon.423a22b5.svg";